import { render, staticRenderFns } from "./HealthServices.vue?vue&type=template&id=4a9840b8&scoped=true&"
import script from "./HealthServices.vue?vue&type=script&lang=js&"
export * from "./HealthServices.vue?vue&type=script&lang=js&"
import style0 from "./HealthServices.vue?vue&type=style&index=0&id=4a9840b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9840b8",
  null
  
)

export default component.exports